<div class="report-template-generators">
  <ng-template #recursiveGenerator
      let-generatorConfigs="generatorConfigs"
      let-currentFormGroup="currentFormGroup"
      let-isTopLevel="isTopLevel"
      let-parentSectionId="parentSectionId">
    @for (generatorConfig of generatorConfigs || []; track generatorConfig) {
      <div class="section-generator" [formGroup]="currentFormGroup.get(generatorConfig.id)">
        <div class="section-generator-header" (click)="toggleGenerator(generatorConfig.id)">
          <div class="chevron">
            <fa-icon [icon]="faChevronRight" [ngClass]="{'expanded': isGeneratorExpanded[generatorConfig.id]}"></fa-icon>
          </div>
          <wm-editable-inlinetext class="name" formControlName="title" placeholder="No title..." [renderHtml]="false"></wm-editable-inlinetext>
          <div class="generator-type">{{ generatorConfig.type }}</div>
          @if (allowEdit && isTopLevel) {
            <p-button icon="true" styleClass="p-button-text p-button-danger" pTooltip="Delete section" (click)="$event.stopPropagation(); deleteSection(generatorConfig.id)">
              <fa-icon [icon]="faTrash"></fa-icon>
            </p-button>
          }
          @if (allowEdit && !isTopLevel && parentSectionId) {
            <p-button icon="true" styleClass="p-button-text p-button-danger" pTooltip="Delete subsection" (click)="$event.stopPropagation(); deleteSubsection(parentSectionId, generatorConfig.id)">
              <fa-icon [icon]="faTrash"></fa-icon>
            </p-button>
          }
        </div>
        @if (generatorConfig.type === 'StaticSectionGeneratorConfig') {
          @if (isGeneratorExpanded[generatorConfig.id]) {
            <div class="section-generator-content">
              <div class="form-item">
                <div class="form-item-content content-list">
                  @for (contentItem of (generatorConfig.content || []); track contentItem; let idx = $index) {
                    <div class="content-item">
                      <wm-report-section-content
                        [content]="contentItem"
                        (onContentUpdate)="updateContent(generatorConfig.id, idx, $event)">
                      </wm-report-section-content>
                      @if (allowEdit) {
                        <p-button icon="true" styleClass="p-button-text p-button-danger" pTooltip="Remove content" (click)="deleteContent(generatorConfig.id, idx)">
                          <fa-icon [icon]="faTrash"></fa-icon>
                        </p-button>
                      }
                    </div>
                  }
                  @if (allowEdit) {
                    <div class="add-content-button">
                      <p-button label="Add Text" styleClass="p-button-secondary" (click)="addTextContent(generatorConfig.id)">
                        <fa-icon [icon]="faPlus"></fa-icon>
                      </p-button>
                    </div>
                  }
                </div>
              </div>
              <div class="form-item">
                <div class="form-item-content">
                  <div class="report-template-generators">
                    <ng-container *ngTemplateOutlet="recursiveGenerator; context:{ generatorConfigs: generatorConfig?.subsections, currentFormGroup: currentFormGroup.get(generatorConfig.id).get('subsections'), isTopLevel: false, parentSectionId: generatorConfig.id }"></ng-container>
                  </div>
                  @if (allowEdit) {
                    <div class="add-subsection-button">
                      <p-button label="Add Subsection" styleClass="p-button-secondary" (click)="addSubsection(generatorConfig.id)">
                        <fa-icon [icon]="faPlus"></fa-icon>
                      </p-button>
                    </div>
                  }
                </div>
              </div>
            </div>
          }
        }
        @if (generatorConfig.type === 'ActivitiesSectionGeneratorConfig') {
          @if (isGeneratorExpanded[generatorConfig.id]) {
            <div class="section-generator-content">
              @if (assessmentTasks) {
                <div class="form-item">
                  <div class="form-label">Activities Filter</div>
                  @if (activitiesLoading) {
                    <div class="form-item-content">
                      <p-progressSpinner></p-progressSpinner>
                    </div>
                  }
                  @if (!activitiesLoading) {
                    <div class="form-item-content filter-form">
                      <wm-activities-filter [tasks]="assessmentTasks" [states]="states" [testObjects]="testObjects" [requirements]="auditRequirements"
                                            [specs]="specsList" [hideFiltersDisplay]="false" [shownFilters]="['spec', 'testObject', 'evaluationStatus', 'tag']" (filterChange)="updateActivitiesFilter(generatorConfig.id, $event)"></wm-activities-filter>
                      <button pButton type="button" (click)="showFilterPreview($event, generatorConfig.id)" [disabled]="!statesByTestObjectId || !specs" label="Preview Activities" class="p-button-outlined">
                        <fa-icon [icon]="faEye"></fa-icon>
                      </button>
                      <p-popover #filterPreviewPanel [baseZIndex]="10000" [dismissable]="true" [showCloseIcon]="true">
                        <div class="filter-preview">
                          <div class="filter-preview-content">
                            @for (task of internalFilteredActivities[generatorConfig.id] || []; track task) {
                              <div class="task">
                                <div class="task-evaluation-status">
                                  @if (task.evaluationStatus === 'undecided') {
                                    <fa-icon class="undecided" [icon]="faQuestionCircle" pTooltip="Undecided"></fa-icon>
                                  }
                                  @if (task.evaluationStatus === 'passed') {
                                    <fa-icon class="passed" [icon]="faThumbsUp" pTooltip="Passed"></fa-icon>
                                  }
                                  @if (task.evaluationStatus === 'failed') {
                                    <fa-icon class="failed" [icon]="faThumbsDown" pTooltip="Failed"></fa-icon>
                                  }
                                  @if (task.evaluationStatus === 'notapplicable') {
                                    <fa-icon class="not-applicable" [icon]="faBan" pTooltip="Not applicable"></fa-icon>
                                  }
                                </div>
                                <div class="task-execution-status">
                                  @if (task.executionStatus === 'notstarted') {
                                    <fa-icon class="undecided" [icon]="faTasks" pTooltip="Not started"></fa-icon>
                                  }
                                  @if (task.executionStatus === 'inprogress') {
                                    <fa-icon class="inprogress" [icon]="faRunning" pTooltip="In progress"></fa-icon>
                                  }
                                  @if (task.executionStatus === 'waitingforreview') {
                                    <fa-icon class="waitingforreview" [icon]="faHourglass" pTooltip="Waiting for review"></fa-icon>
                                  }
                                  @if (task.executionStatus === 'finished') {
                                    <fa-icon class="finished" [icon]="faFlagCheckered" pTooltip="Finished"></fa-icon>
                                  }
                                  @if (task.executionStatus === 'skipped') {
                                    <fa-icon class="skipped" [icon]="faForward" pTooltip="Skipped"></fa-icon>
                                  }
                                  @if (task.executionStatus === 'blocked') {
                                    <fa-icon class="blocked" [icon]="faHandPaper" pTooltip="Blocked"></fa-icon>
                                  }
                                </div>
                                <div class="task-info">
                                  <div class="task-spec">{{ specs?.[task.assessedSpec]?.displayId }} {{ specs?.[task.assessedSpec]?.title }}</div>
                                  <div class="task-object">
                                    <fa-icon [icon]="faGlobe"></fa-icon>
                                    {{ getTaskTargetName(task) }}
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </p-popover>
                    </div>
                  }
                </div>
              }
              <div class="form-item">
                <div class="form-label">Grouping</div>
                <div class="form-item-content">
                  <p-selectButton formControlName="grouping" [options]="ActivitiesGroupingOptions"></p-selectButton>
                </div>
              </div>
              <div class="form-item">
                <div class="form-label">Statistics</div>
                <div class="form-item-content">
                  <div class="stats">
                    <div class="add-stats">
                      <div class="form-item-content checkbox-with-label">
                        <p-checkbox formControlName="includedStats" value="findingsByTestObject"></p-checkbox>
                        <div class="label">Add statistics section "Findings by test object"</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }
        }
        @if (generatorConfig.type === 'RequirementResultMatrixSectionGeneratorConfig') {
          @if (isGeneratorExpanded[generatorConfig.id]) {
            <div class="section-generator-content">
              @if (assessmentTasks) {
                <div class="form-item">
                  <div class="form-label">Activities Filter</div>
                  @if (activitiesLoading) {
                    <div class="form-item-content">
                      <p-progressSpinner></p-progressSpinner>
                    </div>
                  }
                  @if (!activitiesLoading) {
                    <div class="form-item-content filter-form">
                      <wm-activities-filter [tasks]="assessmentTasks" [states]="states" [testObjects]="testObjects" [requirements]="auditRequirements"
                                            [specs]="specsList" [hideFiltersDisplay]="false" [shownFilters]="['spec', 'testObject', 'evaluationStatus', 'tag']" (filterChange)="updateActivitiesFilter(generatorConfig.id, $event)"></wm-activities-filter>
                    </div>
                  }
                </div>
              }
              <div class="form-item">
                <div class="form-label">Legend</div>
                <div class="form-item-content checkbox-with-label">
                  <p-checkbox formControlName="includeLegend" [binary]="true"></p-checkbox>
                  <div class="label">Add table legend</div>
                </div>
              </div>
              <div class="form-item">
                <div class="form-label">Caption</div>
                <div class="form-item-content">
                  <input type="text" formControlName="caption">
                </div>
              </div>
            </div>
          }
        }
        @if (generatorConfig.type === 'TableOfContentsGeneratorConfig') {
        }
      </div>
    }
  </ng-template>

  <ng-container *ngTemplateOutlet="recursiveGenerator; context:{ generatorConfigs: sections, currentFormGroup: currentFormGroup, isTopLevel: true }"></ng-container>

  @if (allowEdit) {
    <div class="add-section-button">
      <p-button label="Add Static Section" styleClass="p-button-secondary" (click)="addStaticSection()">
        <fa-icon [icon]="faPlus"></fa-icon>
      </p-button>
    </div>
  }
</div>
